import React, { useEffect, useState } from 'react'
import { doctors } from '../../Assets/dummyDoc'
import { diagonistics } from '../../Assets/dummyDiagons'
import Header from '../Core/Header'
import { approveHospitalRequest, getAllDiagnosticRequest, getAllHospitalRequest, getAllHospitals } from '../../service/operations/api_methods'

const dummyTest=["Blood Tests","Urine Routine & Microscopy","X-Ray","Ultrasound / Sonography","Stool Routine & Microscopy","Thyroid Tests (TSH, T3, T4)","ECG (Electrocardiogram)",""];


const dummyClinic=["Appolo","Ruby Hospital","Cure & Care","Peerless"];
const Request = () => {
   const[list1,setList1]=useState(doctors)
    const[list2,setList2]=useState(diagonistics)

    const[hospitals,setHospitals]=useState([])

    const handleGetHospitalRequest=async()=>{
        try {
            const response=await getAllHospitalRequest()
            console.log("getAllHospitalRequest",response);
            if(response.status===200){
                setList1(response.data.data)
            }
            
        } catch (error) {
            console.log(error);
            
        }
    }

        const handleGetDiagnosticRequest=async()=>{
        try {
            const response=await getAllDiagnosticRequest()
            console.log("getAllDiagnosticRequest",response);
            if(response.status===200){
                setList2(response.data.data)
            }
            
        } catch (error) {
            console.log(error);
            
        }
    }

    const handleApproveHospitalRequest=async(id)=>{
        let data={  mapping_id: id,      
      action: "APPROVE" }
        try {
            const response=await approveHospitalRequest(data)
            console.log(response);
            if(response.status===200){
                alert("Accepted")
                  handleGetHospitalRequest()
            }
            
        } catch (error) {
           console.log(error);
            
        }
    }

        const fetchHospitals = async () => {
                try {
                    const res = await getAllHospitals()
                    
                    console.log("list of hospital",res.data);
                    if(res.status===200){
                        setHospitals(res.data.data)
                    }
                    
    
                   
                } catch (error) {
                    console.log("Error fetching hospitals:", error)
                }
            }
    
        useEffect(() => {
           
            fetchHospitals()
        }, [])


    useEffect(() => {
     handleGetHospitalRequest()
     handleGetDiagnosticRequest()
    }, [])
    
  return (
    <div style={{height:"100vh",width:"100%"}}>
      <Header/>
      <section style={{marginTop:"80px",height:"calc(100vh - 80px)",background: "linear-gradient(180deg, #555454ff, #ffffffff, #5f5f5fff)",padding:"20px"}}>
        <div style={{fontSize:"24px",fontWeight:"700",textAlign:"center",display:"flex",justifyContent:"space-around",padding:"6px"}}>
            <p style={{color:"white"}}>Request of Hospitals</p>
            <p style={{color:"white"}}>Request of Diagnostic Center</p>
            </div>
            <div style={{display:"flex",width:'100%'}}>
            <div style={{height:"calc(100vh - 100px)",display:"flex",flexWrap:"wrap",width:"50%",overflowY:"auto",overflowX:"hidden",scrollbarWidth: "none", msOverflowStyle: "none",}}>
            {list1.length<1 ?<p>No request from hospitals</p>
            :
            list1.map((item)=>(
                <div style={{width:"20vw",minHeight:"40vh",maxHeight:"fit-content",borderRadius:"10px",padding:"10px",backgroundColor:"#c5c4c4ff",
                    display:"flex",flexDirection:"column",alignItems:"center",margin:"10px",position:"relative"
                }}>
                    <p onClick={()=>handleApproveHospitalRequest(item.id)}
                    style={{padding:"10px",borderRadius:"5px",backgroundColor:"#042b64ff",color:"white",fontSize:"14px",cursor:"pointer",
                        position:"absolute",right:"30px"
                    }}>
                        Accept</p>
                    <img src='/Assets/diagonasitic.jpg' style={{height:"100px",width:"85%",borderRadius:"10px"}}/>
                    <div style={{display:"flex",flexDirection:"column",alignItems:"start",width:"90%"}}>
                        <p style={{fontSize:"20px",textAlign:"left",fontWeight:"500"}}>{
                    }</p>
                        <p style={{width:"100%",display:"flex",justifyContent:"space-between"}}>
                            <span style={{fontSize:'14px',fontWeight:"700",color:"#d65d3eff"}}>Patients:{2000}+</span>
                            <span style={{fontSize:'14px',fontWeight:"700",color:"#6fa0d8ff"}}>reg:{item.hospital?.license_number||""}</span></p>
                        <p style={{width:"100%",display:"flex",justifyContent:"space-between"}}>
                            <span style={{fontSize:'16px',fontWeight:"700",color:"#a3343aff"}}>{item.hospital?.address||""}</span></p>
                           
                        <p style={{fontSize:"14px",fontWeight:"800"}}>Medical Test provided</p>
                        <div style={{width:"100%",display:"flex",alignItems:"center",gap:"10px",flexWrap:"wrap"}}>
                            
                            {
                            dummyTest.map(i=>
                            <p style={{fontSize:"12px",padding:"3px",borderRadius:"8px",backgroundColor:"#041c3bff",color:"white"}}>{i}</p>)
                        }</div>
                            <p style={{fontSize:"14px",fontWeight:"800"}}>Assigned Hospital</p>
                         <div style={{width:"100%",display:"flex",alignItems:"center",gap:"10px",flexWrap:"wrap"}}>
                            
                            {
                           dummyClinic.map(i=>
                            <p style={{fontSize:"12px",padding:"3px",borderRadius:"8px",backgroundColor:"#053d2cff",color:"#fcfcfcff"}}>{i}</p>)
                        }</div>
                     </div>

                    </div>
            ))
            }

        </div>
        
           <div style={{height:"calc(100vh - 100px)",display:"flex",flexWrap:"wrap",width:"50%",overflowY:"auto",overflowX:"hidden",scrollbarWidth: "none", msOverflowStyle: "none",}}>
            {
            list2.map((item)=>(
                 <div style={{width:"20vw",minHeight:"40vh",maxHeight:"fit-content",borderRadius:"10px",padding:"10px",backgroundColor:"#c5c4c4ff",
                    display:"flex",flexDirection:"column",alignItems:"center",margin:"10px",position:"relative"
                }}>
                    <p style={{padding:"10px",borderRadius:"5px",backgroundColor:"#042b64ff",color:"white",fontSize:"14px",cursor:"pointer",
                        position:"absolute",right:"30px"
                    }}>
                        Accept</p>
                    <img src='/Assets/diagonasitic.jpg' style={{height:"100px",width:"85%",borderRadius:"10px"}}/>
                    {/* <div style={{display:"flex",flexDirection:"column",alignItems:"start",width:"90%"}}>
                        <p style={{fontSize:"20px",textAlign:"left",fontWeight:"500"}}>{item.hospital.hospital_name}</p>
                        <p style={{width:"100%",display:"flex",justifyContent:"space-between"}}>
                            <span style={{fontSize:'14px',fontWeight:"700",color:"#d65d3eff"}}>Patients:{2000}+</span>
                            <span style={{fontSize:'14px',fontWeight:"700",color:"#6fa0d8ff"}}>reg:{item.hospital.license_number}</span></p>
                        <p style={{width:"100%",display:"flex",justifyContent:"space-between"}}>
                            <span style={{fontSize:'16px',fontWeight:"700",color:"#a3343aff"}}>{item.hospital.address}</span></p>
                           
                        <p style={{fontSize:"14px",fontWeight:"800"}}>Medical Test provided</p>
                        <div style={{width:"100%",display:"flex",alignItems:"center",gap:"10px",flexWrap:"wrap"}}>
                            
                            {
                            dummyTest.map(i=>
                            <p style={{fontSize:"12px",padding:"3px",borderRadius:"8px",backgroundColor:"#041c3bff",color:"white"}}>{i}</p>)
                        }</div>
                            <p style={{fontSize:"14px",fontWeight:"800"}}>Assigned Hospital</p>
                         <div style={{width:"100%",display:"flex",alignItems:"center",gap:"10px",flexWrap:"wrap"}}>
                            
                            {
                           dummyClinic.map(i=>
                            <p style={{fontSize:"12px",padding:"3px",borderRadius:"8px",backgroundColor:"#053d2cff",color:"#fcfcfcff"}}>{i}</p>)
                        }</div>
                     </div> */}

                    </div>
            ))
            }

        </div>

            </div>
      </section>
    </div>
  )
}

export default Request
